import { Component } from "@theme/component";

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();

    for (const table of this.querySelectorAll("table")) {
      this.#formatTable(table);
    }
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement("div");
    wrapper.classList.add("rte-table-wrapper");
    const parent = table.parentNode;

    if (parent) {
      table.before(wrapper);
      wrapper.append(table);
    }
  }
}

if (!customElements.get("rte-formatter")) {
  customElements.define("rte-formatter", RTEFormatter);
}
